// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#detailsRelated {
  margin-top: 120px;
}
#detailsRelated .tabIcon:before {
  display: inline-block;
  width: auto;
  height: auto;
  position: relative;
  padding-right: 25px;
  background-color: unset;
  font-family: "LineIcons";
  font-weight: bold;
  font-size: 36px;
}
#detailsRelated .tabIcon.icon-longDesc:before {
  content: "\\f2ce";
  left: 3px;
  top: 5px;
}
#detailsRelated .tabIcon.icon-authors:before {
  content: "\\f3f1";
  left: 0;
  top: 9px;
}
#detailsRelated .tabIcon.icon-topics:before {
  content: "\\ef75";
  top: 7px;
  left: -1px;
}
#detailsRelated .tab-content {
  margin-top: 50px;
}
#detailsRelated .tab-pane > :first-child {
  margin-top: 0;
}
#detailsRelated .nav-tabs li {
  margin-bottom: 20px;
  position: relative;
  display: table;
}
#detailsRelated .tab-pane h2 strong, #detailsRelated .tab-pane h2 b {
  font-weight: normal !important;
}
@media (max-width: 991.98px) {
  #detailsRelated {
    margin-top: 70px;
  }
  #detailsRelated .tab-content {
    margin-top: 30px;
  }
}
@media (max-width: 767.98px) {
  #detailsRelated {
    margin-top: 60px;
  }
  #detailsRelated .tab-content {
    margin-top: 20px;
  }
}

#tabTopics ul,
#tabAuthors ul,
#tabLongDesc ul {
  column-count: 2;
  column-gap: 40px;
  list-style-type: none !important;
}
@media (max-width: 575.98px) {
  #tabTopics ul,
  #tabAuthors ul,
  #tabLongDesc ul {
    column-count: 1;
  }
}
#tabTopics ul li,
#tabAuthors ul li,
#tabLongDesc ul li {
  position: relative;
  margin-bottom: 20px;
  padding-left: 30px;
  page-break-inside: avoid;
  break-inside: avoid;
}
#tabTopics ul li:before,
#tabAuthors ul li:before,
#tabLongDesc ul li:before {
  content: "";
  background-color: #005790;
  display: inline-block;
  width: 10px;
  height: 10px;
  position: absolute;
  top: 13px;
  left: 0px;
}

#productDetailZoomModal .modal-content {
  max-width: 766px;
  max-height: 100vh;
  height: 898px;
  background-color: #fff;
  margin-left: auto;
  margin-right: auto;
  padding: 82px 73px 64px;
  overflow: hidden;
}
@media (max-width: 991.98px) {
  #productDetailZoomModal .modal-content {
    padding: 70px 30px;
  }
}
@media (max-width: 767.98px) {
  #productDetailZoomModal .modal-content {
    padding: 70px 15px;
  }
}
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter {
  max-width: 100%;
  position: relative;
  margin-right: 60px;
  margin-left: 60px;
}
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-next,
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-prev {
  color: #005790;
  opacity: 1;
}
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-next:after,
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-prev:after {
  font-family: "LineIcons";
  font-size: 34px;
  transition: color 150ms linear;
  position: relative;
}
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-next:before,
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-prev:before {
  content: "";
  display: block;
  width: 0;
  height: 0;
  background-color: #3dbea2;
  position: absolute;
  border-radius: 50%;
  transition: width 150ms linear, height 150ms linear;
}
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-next:hover,
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-prev:hover {
  cursor: pointer;
}
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-next:hover:before,
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-prev:hover:before {
  width: 70px;
  height: 70px;
}
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-next:hover:after,
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-prev:hover:after {
  color: #fff;
}
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-next.swiper-button-disabled,
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-prev.swiper-button-disabled {
  opacity: 0;
}
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-next {
  left: auto;
  right: -60px;
  width: 60px;
  padding-left: 27px;
  min-width: auto;
}
@media (max-width: 767.98px) {
  #productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-next {
    right: calc(50% - 158px - 60px);
  }
}
@media (max-width: 500px) {
  #productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-next {
    right: calc(50% - 102px - 60px);
    padding-left: 20px;
  }
}
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-next:after {
  content: "\\ea84";
}
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-prev {
  right: auto;
  left: -60px;
  width: 60px;
  padding-right: 27px;
  min-width: auto;
}
@media (max-width: 767.98px) {
  #productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-prev {
    left: calc(50% - 158px - 60px);
  }
}
@media (max-width: 500px) {
  #productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-prev {
    left: calc(50% - 102px - 60px);
    padding-right: 20px;
  }
}
#productDetailZoomModal .zoomProductPicturesSliderThumbContainerOuter .swiper-button-prev:after {
  content: "\\ea77";
}
#productDetailZoomModal .zoomProductPicturesSliderContainer {
  max-width: 620px;
  width: 100%;
  height: calc(100vh - 232px);
  margin-bottom: 40px;
}
#productDetailZoomModal .zoomProductPicturesSliderContainer .swiper-slide {
  height: 100%;
}
#productDetailZoomModal .zoomProductPicturesSliderContainer .swiper-slide a {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
#productDetailZoomModal .zoomProductPicturesSliderContainer .swiper-slide a img {
  max-height: 100%;
}
#productDetailZoomModal .zoomProductPicturesSliderContainer .imgIconCon {
  width: 100%;
  height: 100%;
}
#productDetailZoomModal .zoomProductPicturesSliderContainer .easyzoom {
  width: 100%;
}
@media (max-width: 767.98px) {
  #productDetailZoomModal .zoomProductPicturesSliderThumbContainer {
    max-width: 316px;
  }
}
@media (max-width: 500px) {
  #productDetailZoomModal .zoomProductPicturesSliderThumbContainer {
    max-width: 204px;
  }
}
#productDetailZoomModal .zoomProductPicturesSliderThumbContainer .swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e0ddd6;
  padding: 10px;
}
#productDetailZoomModal .zoomProductPicturesSliderThumbContainer .swiper-slide img {
  max-height: 70px;
}
#productDetailZoomModal .zoomProductPicturesSliderThumbContainer img:hover {
  cursor: pointer;
}

#excerptModal .modal-content {
  background-color: #fff;
  max-width: 991px;
  margin-left: auto;
  margin-right: auto;
  padding: 82px 73px 64px;
  overflow: hidden;
  height: calc(100vh - 100px);
}
@media (max-width: 991.98px) {
  #excerptModal .modal-content {
    padding: 70px 30px;
  }
}
@media (max-width: 767.98px) {
  #excerptModal .modal-content {
    padding: 70px 15px;
  }
}
#excerptModal .modal-content iframe {
  height: 100%;
}

.loadingiconbg,
.loadingicon,
.loadingfade {
  max-width: 100%;
}

.reviewsContainerWrap .buttonsContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 10px;
  margin-left: -20px;
}
.reviewsContainerWrap .buttonsContainer .btn {
  margin-top: 20px;
  margin-left: 20px;
}

.reviewsContainer {
  margin-top: 94px;
}

.review {
  margin-bottom: 50px;
}
.review:nth-child(n+4) {
  display: none;
}
.review .ratingContainer {
  margin-bottom: 22px;
  color: #005790;
}
.review .ratingContainer .lni {
  width: 30px;
  font-size: 30px;
}
.review .ratingContainer .lni + .lni {
  margin-left: 14px;
}
.review .ratingContainer.starCount5 .lni:first-child, .review .ratingContainer.starCount4 .lni:first-child, .review .ratingContainer.starCount3 .lni:first-child, .review .ratingContainer.starCount2 .lni:first-child, .review .ratingContainer.starCount1 .lni:first-child {
  font-size: 30px;
}
.review .ratingContainer.starCount5 .lni:nth-child(2), .review .ratingContainer.starCount4 .lni:nth-child(2), .review .ratingContainer.starCount3 .lni:nth-child(2), .review .ratingContainer.starCount2 .lni:nth-child(2) {
  font-size: 30px;
}
.review .ratingContainer.starCount5 .lni:nth-child(3), .review .ratingContainer.starCount4 .lni:nth-child(3), .review .ratingContainer.starCount3 .lni:nth-child(3) {
  font-size: 30px;
}
.review .ratingContainer.starCount5 .lni:nth-child(4), .review .ratingContainer.starCount4 .lni:nth-child(4) {
  font-size: 30px;
}
.review .ratingContainer.starCount5 .lni:nth-child(5) {
  font-size: 30px;
}
.review .metadata {
  max-width: 300px;
  font-size: 16px;
  line-height: 24px;
}
.review .text {
  max-width: 350px;
  font-size: 18px;
  line-height: 30px;
  margin-top: 11px;
}
@media (max-width: 767.98px) {
  .review:nth-child(n+3) {
    display: none;
  }
}
@media (max-width: 575.98px) {
  .review .metadata {
    max-width: none;
  }
  .review .text {
    max-width: none;
  }
}

.productReviewForm .ratingContainer {
  color: #005790;
  margin-left: -7px;
}
.productReviewForm .ratingContainer .lni {
  width: 44px;
  font-size: 30px;
  padding-right: 7px;
  padding-left: 7px;
  cursor: pointer;
}
.productReviewForm .ratingContainer .lni + .lni {
  margin-left: 0;
}
.productReviewForm .ratingContainer.starCount5 .lni:first-child, .productReviewForm .ratingContainer.starCount4 .lni:first-child, .productReviewForm .ratingContainer.starCount3 .lni:first-child, .productReviewForm .ratingContainer.starCount2 .lni:first-child, .productReviewForm .ratingContainer.starCount1 .lni:first-child {
  font-size: 30px;
}
.productReviewForm .ratingContainer.starCount5 .lni:nth-child(2), .productReviewForm .ratingContainer.starCount4 .lni:nth-child(2), .productReviewForm .ratingContainer.starCount3 .lni:nth-child(2), .productReviewForm .ratingContainer.starCount2 .lni:nth-child(2) {
  font-size: 30px;
}
.productReviewForm .ratingContainer.starCount5 .lni:nth-child(3), .productReviewForm .ratingContainer.starCount4 .lni:nth-child(3), .productReviewForm .ratingContainer.starCount3 .lni:nth-child(3) {
  font-size: 30px;
}
.productReviewForm .ratingContainer.starCount5 .lni:nth-child(4), .productReviewForm .ratingContainer.starCount4 .lni:nth-child(4) {
  font-size: 30px;
}
.productReviewForm .ratingContainer.starCount5 .lni:nth-child(5) {
  font-size: 30px;
}

#review_form .smallWrapper {
  margin-top: 80px;
  margin-bottom: 0;
}
#review_form textarea {
  display: block;
}
#review_form .submitButtonContainer {
  display: flex;
  margin-top: 20px;
}
#review_form .submitButton {
  margin-left: auto;
}

#loginForReview .textlink {
  color: #3dbea2;
  font-weight: 700;
  font-size: 18px;
}

.productVideo {
  position: relative;
  max-height: 524px;
}
.productVideo .background {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.productVideo:before {
  display: block;
  content: "";
  padding-top: 32.75%;
}
@media (max-width: 991.98px) {
  .productVideo {
    max-height: none;
  }
  .productVideo:before {
    display: none;
  }
}

.productVideoInner {
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.productVideoInner .videoContainer {
  width: 50%;
}
.productVideoInner iframe {
  width: 100%;
  height: 100%;
}
.productVideoInner .textContainer {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  padding: 30px;
}
.productVideoInner .textContainerInner {
  width: 600px;
}
@media (min-width: 1600px) {
  .productVideoInner .textContainerInner {
    position: absolute;
    left: 94px;
  }
}
.productVideoInner .checklistHeadline {
  position: relative;
  color: #fff;
  margin-top: 0;
}
.productVideoInner .checklistContainer li {
  font-size: 20px;
  line-height: 34px;
  color: #fff;
}
.productVideoInner .checklistContainer li:before {
  top: 0;
  color: #fff;
}
.productVideoInner .playNowContainer {
  margin-top: 20px;
  margin-left: -10px;
}
.productVideoInner .playNow {
  padding: 10px;
  color: #3dbea2;
  font-size: 24px;
  line-height: 30px;
}
.productVideoInner .playNow:after {
  width: 54px;
  left: 10px;
}
.productVideoInner .playNow:hover:after {
  width: 100px;
}
@media (max-width: 1199.98px) {
  .productVideoInner .checklistContainer li {
    font-size: 18px;
    line-height: 30px;
  }
  .productVideoInner .checklistContainer li:before {
    font-size: 21px;
  }
  .productVideoInner .playNowContainer {
    margin-top: 0;
  }
  .productVideoInner .playNow {
    font-size: 20px;
  }
}
@media (max-width: 991.98px) {
  .productVideoInner {
    display: block;
    position: static;
  }
  .productVideoInner .videoContainer {
    position: relative;
    width: 100%;
  }
  .productVideoInner .videoContainer:before {
    display: block;
    content: "";
    padding-top: 56.25%;
  }
  .productVideoInner iframe {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .productVideoInner .textContainer {
    display: block;
    width: 100%;
  }
  .productVideoInner .textContainerInner {
    width: auto;
  }
  .productVideoInner .playNowContainer {
    margin-top: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./build/scss/_product-detail.scss","webpack://./build/scss/_variables.scss","webpack://./build/scss/bootstrap/mixins/_breakpoints.scss"],"names":[],"mappings":"AAKA;EACI,iBC0DuB;AD9D3B;AAOQ;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,iBAAA;EACA,eAAA;AALZ;AASY;EACI,gBAAA;EACA,SAAA;EACA,QAAA;AAPhB;AAYY;EACI,gBAAA;EACA,OAAA;EACA,QAAA;AAVhB;AAeY;EACI,gBAAA;EACA,QAAA;EACA,UAAA;AAbhB;AAkBI;EACI,gBAAA;AAhBR;AAmBI;EACI,aAAA;AAjBR;AAqBQ;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;AAnBZ;AAyBY;EACI,8BAAA;AAvBhB;AE+BI;EFpEJ;IAkEQ,gBCLkB;EDpBxB;EA2BM;IACI,gBAAA;EAzBV;AACF;AEuBI;EFpEJ;IA0EQ,gBCZsB;EDb5B;EA2BM;IACI,gBAAA;EAzBV;AACF;;AAgCI;;;EACI,eAAA;EACA,gBAAA;EACA,gCAAA;AA3BR;AEOI;EFiBA;;;IAMQ,eAAA;EAxBV;AACF;AA0BQ;;;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;AAtBZ;AAwBY;;;EACI,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AApBhB;;AA2BI;EACI,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;AAxBR;AEhCI;EFgDA;IAWQ,kBAAA;EAvBV;AACF;AErCI;EFgDA;IAeQ,kBAAA;EAtBV;AACF;AAyBI;EACI,eAAA;EAEA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAxBR;AA0BQ;;EAEI,cC9HL;ED+HK,UAAA;AAxBZ;AA0BY;;EACI,wBAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;AAvBhB;AA0BY;;EACI,WAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,yBCzIR;ED0IQ,kBAAA;EACA,kBAAA;EACA,mDAAA;AAvBhB;AA0BY;;EACI,eAAA;AAvBhB;AAyBgB;;EACI,WAAA;EACA,YAAA;AAtBpB;AAyBgB;;EACI,WAAA;AAtBpB;AA0BY;;EACI,UAAA;AAvBhB;AA2BQ;EACI,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAzBZ;AE/FI;EFmHI;IAQQ,+BAAA;EAxBd;AACF;AA0BY;EAXJ;IAYQ,+BAAA;IACA,kBAAA;EAvBd;AACF;AAyBY;EACI,gBAAA;AAvBhB;AA2BQ;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AAzBZ;AEpHI;EFwII;IAQQ,8BAAA;EAxBd;AACF;AA0BY;EAXJ;IAYQ,8BAAA;IACA,mBAAA;EAvBd;AACF;AAyBY;EACI,gBAAA;AAvBhB;AA4BI;EACI,gBAAA;EACA,WAAA;EACA,2BAAA;EACA,mBAAA;AA1BR;AA4BQ;EACI,YAAA;AA1BZ;AA4BY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AA1BhB;AA4BgB;EACI,gBAAA;AA1BpB;AA+BQ;EACI,WAAA;EACA,YAAA;AA7BZ;AAgCQ;EACI,WAAA;AA9BZ;AE3JI;EF6LA;IAEQ,gBAAA;EAhCV;AACF;AAkCQ;EALJ;IAMQ,gBAAA;EA/BV;AACF;AAkCQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;AAhCZ;AAkCY;EACI,gBAAA;AAhChB;AAqCY;EACI,eAAA;AAnChB;;AA0CI;EACI,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,2BAAA;AAvCR;AE5LI;EF4NA;IAUQ,kBAAA;EAtCV;AACF;AEjMI;EF4NA;IAcQ,kBAAA;EArCV;AACF;AAuCQ;EACI,YAAA;AArCZ;;AA0CA;;;EAGI,eAAA;AAvCJ;;AA2CI;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAxCR;AA0CQ;EACI,gBAAA;EACA,iBAAA;AAxCZ;;AA6CA;EACI,gBAAA;AA1CJ;;AA6CA;EACI,mBAAA;AA1CJ;AA4CI;EACI,aAAA;AA1CR;AA6CI;EACI,mBAAA;EACA,cCvUD;AD4RP;AA6CQ;EACI,WAAA;EACA,eAAA;AA3CZ;AA6CY;EACI,iBAAA;AA3ChB;AAsDgB;EACI,eAAA;AApDpB;AA8DgB;EACI,eAAA;AA5DpB;AAqEgB;EACI,eAAA;AAnEpB;AA2EgB;EACI,eAAA;AAzEpB;AAgFgB;EACI,eAAA;AA9EpB;AAoFI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AAlFR;AAqFI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAnFR;AE3QI;EFkWI;IACI,aAAA;EApFV;AACF;AEhRI;EFwWI;IACI,eAAA;EArFV;EAwFM;IACI,eAAA;EAtFV;AACF;;AA2FI;EACI,cCtaD;EDuaC,iBAAA;AAxFR;AA0FQ;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAxFZ;AA0FY;EACI,cAAA;AAxFhB;AAmGgB;EACI,eAAA;AAjGpB;AA2GgB;EACI,eAAA;AAzGpB;AAkHgB;EACI,eAAA;AAhHpB;AAwHgB;EACI,eAAA;AAtHpB;AA6HgB;EACI,eAAA;AA3HpB;;AAmII;EACI,gBAAA;EAGA,gBAAA;AAlIR;AAqII;EAEI,cAAA;AApIR;AAuII;EACI,aAAA;EACA,gBAAA;AArIR;AAwII;EACI,iBAAA;AAtIR;;AA2II;EACI,cC/fA;EDggBA,gBAAA;EACA,eAAA;AAxIR;;AA4IA;EACI,kBAAA;EACA,iBAAA;AAzIJ;AA2II;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAzIR;AA4II;EACI,cAAA;EACA,WAAA;EACA,mBAAA;AA1IR;AE9VI;EFudJ;IAqBQ,gBAAA;EA1IN;EA4IM;IACI,aAAA;EA1IV;AACF;;AA8IA;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AA3IJ;AA6II;EACI,UAAA;AA3IR;AA8II;EACI,WAAA;EACA,YAAA;AA5IR;AA+II;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;AA7IR;AAgJI;EACI,YAAA;AA9IR;AAgJQ;EAHJ;IAIQ,kBAAA;IACA,UAAA;EA7IV;AACF;AAgJI;EACI,kBAAA;EACA,WAAA;EACA,aAAA;AA9IR;AAkJQ;EACI,eAAA;EACA,iBAAA;EACA,WAAA;AAhJZ;AAkJY;EACI,MAAA;EACA,WAAA;AAhJhB;AAqJI;EACI,gBAAA;EACA,kBAAA;AAnJR;AAsJI;EACI,aAAA;EACA,cC/lBA;EDgmBA,eAAA;EACA,iBAAA;AApJR;AAsJQ;EACI,WAAA;EACA,UAAA;AApJZ;AAwJY;EACI,YAAA;AAtJhB;AEtaI;EFmkBQ;IACI,eAAA;IACA,iBAAA;EA1Jd;EA4Jc;IACI,eAAA;EA1JlB;EA+JM;IACI,aAAA;EA7JV;EAgKM;IACI,eAAA;EA9JV;AACF;AErbI;EFofJ;IAmGQ,cAAA;IACA,gBAAA;EA9JN;EAgKM;IACI,kBAAA;IACA,WAAA;EA9JV;EAgKU;IACI,cAAA;IACA,WAAA;IACA,mBAAA;EA9Jd;EAkKM;IACI,kBAAA;IACA,MAAA;IACA,QAAA;IACA,SAAA;IACA,OAAA;EAhKV;EAmKM;IACI,cAAA;IACA,WAAA;EAjKV;EAoKM;IACI,WAAA;EAlKV;EAqKM;IACI,gBAAA;EAnKV;AACF","sourcesContent":["@import 'variables';\n@import 'bootstrap/functions';\n@import 'bootstrap/variables';\n@import 'bootstrap/mixins';\n\n#detailsRelated {\n    margin-top: $fullwidth-margin-desktop;\n\n    .tabIcon {\n        &:before {\n            display: inline-block;\n            width: auto;\n            height: auto;\n            position: relative;\n            padding-right: 25px;\n            background-color: unset;\n            font-family: 'LineIcons';\n            font-weight: bold;\n            font-size: 36px;\n        }\n\n        &.icon-longDesc {\n            &:before {\n                content: \"\\f2ce\";\n                left: 3px;\n                top: 5px;\n            }\n        }\n\n        &.icon-authors {\n            &:before {\n                content: \"\\f3f1\";\n                left: 0;\n                top: 9px;\n            }\n        }\n\n        &.icon-topics {\n            &:before {\n                content: \"\\ef75\";\n                top: 7px;\n                left: -1px;\n            }\n        }\n    }\n\n    .tab-content {\n        margin-top: 50px;\n    }\n\n    .tab-pane > :first-child {\n        margin-top: 0;\n    }\n\n    .nav-tabs {\n        li {\n            margin-bottom: 20px;\n            position: relative;\n            display: table;\n        }\n    }\n\n    .tab-pane {\n        h2 {\n            strong, b {\n                font-weight: normal !important;\n            }\n        }\n    }\n\n    @include media-breakpoint-down(md) {\n        margin-top: $fullwidth-margin-tablet;\n\n        .tab-content {\n            margin-top: 30px;\n        }\n    }\n\n    @include media-breakpoint-down(sm) {\n        margin-top: $fullwidth-margin-smartphone;\n\n        .tab-content {\n            margin-top: 20px;\n        }\n    }\n}\n\n#tabTopics,\n#tabAuthors,\n#tabLongDesc {\n    ul {\n        column-count: 2;\n        column-gap: 40px;\n        list-style-type: none !important;\n\n        @include media-breakpoint-down(xs) {\n            column-count: 1;\n        }\n\n        li {\n            position: relative;\n            margin-bottom: 20px;\n            padding-left: 30px;\n            page-break-inside: avoid;\n            break-inside: avoid;\n\n            &:before {\n                content: \"\";\n                background-color: #005790;\n                display: inline-block;\n                width: 10px;\n                height: 10px;\n                position: absolute;\n                top: 13px;\n                left: 0px;\n            }\n        }\n    }\n}\n\n#productDetailZoomModal {\n    .modal-content {\n        max-width: 766px;\n        max-height: 100vh;\n        height: 898px;\n        background-color: #fff;\n        margin-left: auto;\n        margin-right: auto;\n        padding: 82px 73px 64px;\n        overflow: hidden;\n\n        @include media-breakpoint-down(md) {\n            padding: 70px 30px;\n        }\n\n        @include media-breakpoint-down(sm) {\n            padding: 70px 15px;\n        }\n    }\n\n    .zoomProductPicturesSliderThumbContainerOuter {\n        max-width: 100%;\n        // flex-basis: 100%;\n        position: relative;\n        margin-right: 60px;\n        margin-left: 60px;\n\n        .swiper-button-next,\n        .swiper-button-prev {\n            color: $blue;\n            opacity: 1;\n\n            &:after {\n                font-family: 'LineIcons';\n                font-size: 34px;\n                transition: color $transition-duration-fast linear;\n                position: relative;\n            }\n\n            &:before {\n                content: \"\";\n                display: block;\n                width: 0;\n                height: 0;\n                background-color: $green;\n                position: absolute;\n                border-radius: 50%;\n                transition: width $transition-duration-fast linear, height $transition-duration-fast linear;\n            }\n\n            &:hover {\n                cursor: pointer;\n\n                &:before {\n                    width: 70px;\n                    height: 70px;\n                }\n\n                &:after {\n                    color: #fff;\n                }\n            }\n\n            &.swiper-button-disabled {\n                opacity: 0;\n            }\n        }\n\n        .swiper-button-next {\n            left: auto;\n            right: -60px;\n            width: 60px;\n            padding-left: 27px;\n            min-width: auto;\n\n            @include media-breakpoint-down(sm) {\n                right: calc(50% - 158px - 60px);\n            }\n\n            @media (max-width: 500px) {\n                right: calc(50% - 102px - 60px);\n                padding-left: 20px;\n            }\n\n            &:after {\n                content: \"\\ea84\";\n            }\n        }\n\n        .swiper-button-prev {\n            right: auto;\n            left: -60px;\n            width: 60px;\n            padding-right: 27px;\n            min-width: auto;\n\n            @include media-breakpoint-down(sm) {\n                left: calc(50% - 158px - 60px);\n            }\n\n            @media (max-width: 500px) {\n                left: calc(50% - 102px - 60px);\n                padding-right: 20px;\n            }\n\n            &:after {\n                content: \"\\ea77\";\n            }\n        }\n    }\n\n    .zoomProductPicturesSliderContainer {\n        max-width: 620px;\n        width: 100%;\n        height: calc(100vh - 232px);\n        margin-bottom: 40px;\n\n        .swiper-slide {\n            height: 100%;\n\n            a {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                height: 100%;\n\n                img {\n                    max-height: 100%;\n                }\n            }\n        }\n\n        .imgIconCon {\n            width: 100%;\n            height: 100%;\n        }\n\n        .easyzoom {\n            width: 100%;\n        }\n    }\n\n    .zoomProductPicturesSliderThumbContainer {\n        @include media-breakpoint-down(sm) {\n            max-width: 316px;\n        }\n\n        @media (max-width: 500px) {\n            max-width: 204px;\n\n        }\n\n        .swiper-slide {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border: 1px solid $gray-300;\n            padding: 10px;\n\n            img {\n                max-height: 70px;\n            }\n        }\n\n        img {\n            &:hover {\n                cursor: pointer;\n            }\n        }\n    }\n}\n\n#excerptModal {\n    .modal-content {\n        background-color: #fff;\n        max-width: 991px;\n        margin-left: auto;\n        margin-right: auto;\n        padding: 82px 73px 64px;\n        overflow: hidden;\n        height: calc(100vh - 100px);\n\n        @include media-breakpoint-down(md) {\n            padding: 70px 30px;\n        }\n\n        @include media-breakpoint-down(sm) {\n            padding: 70px 15px;\n        }\n\n        iframe {\n            height: 100%;\n        }\n    }\n}\n\n.loadingiconbg,\n.loadingicon,\n.loadingfade {\n    max-width: 100%;\n}\n\n.reviewsContainerWrap {\n    .buttonsContainer {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        margin-top: 10px;\n        margin-left: -20px;\n\n        .btn {\n            margin-top: 20px;\n            margin-left: 20px;\n        }\n    }\n}\n\n.reviewsContainer {\n    margin-top: 94px;\n}\n\n.review {\n    margin-bottom: 50px;\n\n    &:nth-child(n + 4) {\n        display: none;\n    }\n\n    .ratingContainer {\n        margin-bottom: 22px;\n        color: $blue;\n\n        .lni {\n            width: 30px;\n            font-size: 30px;\n\n            + .lni {\n                margin-left: 14px;\n            }\n        }\n\n        // This looks a bit creepy, but I copied this from _rating.scss.\n        &.starCount5,\n        &.starCount4,\n        &.starCount3,\n        &.starCount2,\n        &.starCount1 {\n            .lni {\n                &:first-child {\n                    font-size: 30px;\n                }\n            }\n        }\n\n        &.starCount5,\n        &.starCount4,\n        &.starCount3,\n        &.starCount2 {\n            .lni {\n                &:nth-child(2) {\n                    font-size: 30px;\n                }\n            }\n        }\n\n        &.starCount5,\n        &.starCount4,\n        &.starCount3 {\n            .lni {\n                &:nth-child(3) {\n                    font-size: 30px;\n                }\n            }\n        }\n\n        &.starCount5,\n        &.starCount4 {\n            .lni {\n                &:nth-child(4) {\n                    font-size: 30px;\n                }\n            }\n        }\n\n        &.starCount5 {\n            .lni {\n                &:nth-child(5) {\n                    font-size: 30px;\n                }\n            }\n        }\n    }\n\n    .metadata {\n        max-width: 300px;\n        font-size: 16px;\n        line-height: 24px;\n    }\n\n    .text {\n        max-width: 350px;\n        font-size: 18px;\n        line-height: 30px;\n        margin-top: 11px;\n    }\n\n    @include media-breakpoint-down(sm) {\n        &:nth-child(n + 3) {\n            display: none;\n        }\n    }\n\n    @include media-breakpoint-down(xs) {\n        .metadata {\n            max-width: none;\n        }\n\n        .text {\n            max-width: none;\n        }\n    }\n}\n\n.productReviewForm {\n    .ratingContainer {\n        color: $blue;\n        margin-left: -7px;\n\n        .lni {\n            width: 44px;\n            font-size: 30px;\n            padding-right: 7px;\n            padding-left: 7px;\n            cursor: pointer;\n\n            + .lni {\n                margin-left: 0;\n            }\n        }\n\n        // This looks a bit creepy, but I copied this from _rating.scss.\n        &.starCount5,\n        &.starCount4,\n        &.starCount3,\n        &.starCount2,\n        &.starCount1 {\n            .lni {\n                &:first-child {\n                    font-size: 30px;\n                }\n            }\n        }\n\n        &.starCount5,\n        &.starCount4,\n        &.starCount3,\n        &.starCount2 {\n            .lni {\n                &:nth-child(2) {\n                    font-size: 30px;\n                }\n            }\n        }\n\n        &.starCount5,\n        &.starCount4,\n        &.starCount3 {\n            .lni {\n                &:nth-child(3) {\n                    font-size: 30px;\n                }\n            }\n        }\n\n        &.starCount5,\n        &.starCount4 {\n            .lni {\n                &:nth-child(4) {\n                    font-size: 30px;\n                }\n            }\n        }\n\n        &.starCount5 {\n            .lni {\n                &:nth-child(5) {\n                    font-size: 30px;\n                }\n            }\n        }\n    }\n}\n\n#review_form {\n    .smallWrapper {\n        margin-top: 80px;\n        // The margin-bottom causes the content below to jump, when the collapse\n        // finishes its opening animation.\n        margin-bottom: 0;\n    }\n\n    textarea {\n        // In chrome this is inline-block by default and adds space below the textarea.\n        display: block;\n    }\n\n    .submitButtonContainer {\n        display: flex;\n        margin-top: 20px;\n    }\n\n    .submitButton {\n        margin-left: auto;\n    }\n}\n\n#loginForReview {\n    .textlink {\n        color: $green;\n        font-weight: 700;\n        font-size: 18px;\n    }\n}\n\n.productVideo {\n    position: relative;\n    max-height: 524px;\n\n    .background {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n    }\n\n    &:before {\n        display: block;\n        content: '';\n        padding-top: percentage(524 / 1600);\n    }\n\n    @include media-breakpoint-down(md) {\n        max-height: none;\n\n        &:before {\n            display: none;\n        }\n    }\n}\n\n.productVideoInner {\n    display: flex;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n\n    .videoContainer {\n        width: 50%;\n    }\n\n    iframe {\n        width: 100%;\n        height: 100%;\n    }\n\n    .textContainer {\n        position: relative;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 50%;\n        padding: 30px;\n    }\n\n    .textContainerInner {\n        width: 600px;\n\n        @media (min-width: 1600px) {\n            position: absolute;\n            left: 94px;\n        }\n    }\n\n    .checklistHeadline {\n        position: relative;\n        color: #fff;\n        margin-top: 0;\n    }\n\n    .checklistContainer {\n        li {\n            font-size: 20px;\n            line-height: 34px;\n            color: #fff;\n\n            &:before {\n                top: 0;\n                color: #fff;\n            }\n        }\n    }\n\n    .playNowContainer {\n        margin-top: 20px;\n        margin-left: -10px;\n    }\n\n    .playNow {\n        padding: 10px;\n        color: $green;\n        font-size: 24px;\n        line-height: 30px;\n\n        &:after {\n            width: 54px;\n            left: 10px;\n        }\n\n        &:hover {\n            &:after {\n                width: 100px;\n            }\n        }\n    }\n\n    @include media-breakpoint-down(lg) {\n        .checklistContainer {\n            li {\n                font-size: 18px;\n                line-height: 30px;\n\n                &:before {\n                    font-size: 21px;\n                }\n            }\n        }\n\n        .playNowContainer {\n            margin-top: 0;\n        }\n\n        .playNow {\n            font-size: 20px;\n        }\n    }\n\n    @include media-breakpoint-down(md) {\n        display: block;\n        position: static;\n\n        .videoContainer {\n            position: relative;\n            width: 100%;\n\n            &:before {\n                display: block;\n                content: '';\n                padding-top: percentage(9 / 16);\n            }\n        }\n\n        iframe {\n            position: absolute;\n            top: 0;\n            right: 0;\n            bottom: 0;\n            left: 0;\n        }\n\n        .textContainer {\n            display: block;\n            width: 100%;\n        }\n\n        .textContainerInner {\n            width: auto;\n        }\n\n        .playNowContainer {\n            margin-top: 10px;\n        }\n    }\n}","//\r\n// Project specific variables\r\n// --------------------------------------------------\r\n\r\n//== Transitions\r\n$transition-duration: 300ms !default;\r\n$transition-duration-fast: 150ms !default;\r\n\r\n$page-width:     1600px;\r\n$page-min-width:  320px;\r\n$content-width:  1420px;\r\n\r\n//\r\n// Bootstrap variables\r\n// --------------------------------------------------\r\n\r\n//== Color system\r\n$white: #ffffff;\r\n$gray-100: #f8f7f4;\r\n$gray-200: #ece9e4;\r\n$gray-300: #e0ddd6;\r\n$gray-400: #001f37;\r\n\r\n$blue: #005790;\r\n$blue-light: #aebacc;\r\n$blue-dark: #003151;\r\n$blue-medium: #004471;\r\n$green: #3dbea2;\r\n$green-dark: #228d76;\r\n$red: #ea7c7c;\r\n$red-light: #ed8f8f;\r\n$brown: #d8bc91;\r\n\r\n$primary: $blue;\r\n$secondary: $green;\r\n\r\n\r\n\r\n//== Body\r\n$body-color: #5f5e5c;\r\n\r\n//== Components\r\n$line-height-base: 1.7;\r\n$line-height-lg: 1.7;\r\n$line-height-sm: 1.7;\r\n\r\n//== Fonts\r\n$font-size-base: 1.25rem; // If we don't use rem, we get compile errors...\r\n\r\n//== Fonts\r\n$font-family-sans-serif: 'Gudea', sans-serif;\r\n\r\n$h1-font-size:   38px;\r\n$h1-line-height: 46px;\r\n\r\n$h2-font-size:   30px;\r\n$h2-line-height: 46px;\r\n\r\n// $h3-font-size:   20px;\r\n// $h3-line-height: 30px;\r\n\r\n//== Links\r\n$link-hover-decoration: none;\r\n\r\n$fullwidth-margin-desktop: 120px;\r\n// $fullwidth-margin-desktop: 90px;\r\n$fullwidth-margin-tablet: 70px;\r\n$fullwidth-margin-smartphone: 60px;\r\n\r\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02px, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
